import { AnimatePresence, motion } from 'framer-motion';
import Loader from './Loader';
import useMeasure from 'react-use-measure';
import { useEffect } from 'react';

export const Modal = ({
  visible,
  loading,
  type = 'modal', 
  children, 
  onOutsideClick, 
  onExitComplete
}: { 
  visible: boolean, 
  loading?: boolean,
  type?: 'modal' | 'drawer', 
  children: React.ReactNode, 
  onOutsideClick?: () => void, 
  onExitComplete?: () => void 
}) => {
  const [ref, { height }] = useMeasure()

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && onOutsideClick) {
        onOutsideClick();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [])

  return (
    <AnimatePresence onExitComplete={onExitComplete}>
      {visible ? (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
          className='fixed z-40 inset-0'
        >
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.8 }}
            transition={{ duration: 0.1 }}
            className='absolute inset-0 bg-black'
            onClick={onOutsideClick}
          />

          <div className={`
              ${type === 'drawer' 
                ? 'absolute inset-0 top-auto md:left-1/2 md:top-1/2 md:-translate-x-1/2 md:-translate-y-1/2 md:right-auto md:bottom-auto md:w-[480px]' 
                : 'absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-full px-6 md:px-0 md:w-[480px]'}
          `}>
            <motion.div
              initial={{ y: '100%', opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ type: 'spring', damping: 30, stiffness: 500 }}
            >
              <motion.div 
                animate={{ height }} 
                transition={{ type: 'spring', damping: 30, stiffness: 500 }}
                className={type === 'drawer' ? `rounded-tl-2xl rounded-tr-2xl bg-white md:rounded-2xl md:overflow-hidden` : 'bg-white rounded-2xl'}>
                <div ref={ref} className={type === 'drawer' ? `relative pb-4 -mb-4 md:pb-0 md:mb-0` : 'relative'}>
                  {loading ? (
                    <div className='flex items-center justify-center w-full h-40'>
                      <Loader size='32px' stroke='#191d29' />
                    </div>
                  ) : (
                    children
                  )}
                </div>
              </motion.div>
              {type === 'drawer' && (
                <div className='absolute bottom-0 left-0 z-0 right-0 h-20 bg-white pointer-events-none md:hidden' style={{ transform: 'translateY(99%)' }} />
              )}
            </motion.div>
          </div>
        </motion.div>

      ) : null}
    </AnimatePresence>
  )
}
